module.exports = __webpack_public_path__ + "static/media/combat(3).6a8b2ddb.PNG";